<template>
  <el-dialog class="delete-rust-contract-dialog common-dialog" title="删除合约文件" :visible.sync="showDialog" top="35vh">
    <el-alert title="删除该合约，则该合约下的所有Task也会被删除" type="warning" show-icon :closable="false"></el-alert>
    <div class="hint">是否删除合约文件【 {{ contractInfo.Filename }} 】？</div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cacel">取 消</el-button>
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'DeleteRustContract',
  props: {
    dialogVisible: Boolean,
    contractInfo: {
      type: Object,
      default: () => {
        return {
          ID: '',
          Filename: '',
          TaskCount: 0,
          CreatedAt: 0,
          UpdatedAt: 0
        }
      }
    }
  },
  data() {
    return {
      showDialog: false
    }
  },
  watch: {
    dialogVisible: function (val) {
      this.showDialog = val
    },
    showDialog: function (val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  methods: {
    cacel() {
      this.showDialog = false
    },
    makeSure() {
      let self = this
      this.$apis.contractdetector
        .deleteRustContract({
          contract_id: self.contractInfo.ID
        })
        .then(res => {
          if (res && res.message && res.code === 0) {
            self.showDialog = false

            self.$emit('deleteSuccess')
            self.$message({
              type: 'success',
              message: '删除合约文件成功!'
            })
          } else {
            if (!res.error) {
              self.$message({
                type: 'error',
                message: '删除合约文件失败!'
              })
            } else {
              const h = self.$createElement
              self.$message({
                type: 'error',
                message: h('p', null, [
                  h('div', { style: 'color: red' }, '删除合约文件失败!'),
                  h('div', { style: 'color: teal' }, res.error)
                ])
              })
            }
          }
          // console.log(res)
        })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.delete-rust-contract-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }
  .hint {
    padding: var(--base-size-8) var(--base-size-16);
    margin-bottom: var(--base-size-20);
  }
}
</style>
